<div class="side-menu ps-lg-5 h-100">
    <h6>{{title}}</h6>
    <ul class="nav flex-column">
        <li *ngFor="let menu of menus" [routerLinkActive]="'active'" class="nav-item">
            <a class="nav-link" [routerLink]="menu.route"> {{ menu.label }}
            </a>
        </li>
    </ul>
</div>